import styled from 'styled-components';

import LayoutPageImage from '../../assets/Page.svg';

export const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  background-image: url(${LayoutPageImage});
  object-fit: contain;
  display: flex;
  align-items: center;
  justify-content: center;
`;
